module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5LjE5IDEwLjQ5Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzZhODE4Yjt9PC9zdHlsZT48L2RlZnM+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iNC42IDAgMCA0LjYgOS4xOSA0LjYgNC42IDAiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHk9IjUuNzIiIHdpZHRoPSI5LjE5IiBoZWlnaHQ9IjEuODIiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHk9IjguNjciIHdpZHRoPSI5LjE5IiBoZWlnaHQ9IjEuODIiLz48L2c+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/svg/boost.svg
// module id = Otqg
// module chunks = 13